export enum BracketType {
  'DAMON_ULTIMA_STOCK_5_5' = 'Damon Ultima-Stock, 5-5',
}

export enum BracketTypeLocalizationKey {
  'DAMON_ULTIMA_STOCK_5_5' = 'DAMON_ULTIMA_STOCK_5_5',
}
